<template>
  <div>
    <table-cadu
      v-if="!isLoading"
      class="emailArea mt-8"
      v-model="selected"
      nameTab="TabelaEmailAreas"
      custom
      :showDownload="true"
      :botaoSelecionarLixeira="false"
      :loading="isLoading"
      :showCheck="true"
      :selectCheckIndex="true"
      :items="['05', '10','15']"
      :elementsPerPageProp="elementsPerPage"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :showSelect="true"
      :showFiltro="true"
      :rows="rows"
      :rowsHeader="rowsHeader"
      :disabledButtons="[false]"
      :disabledAllButtons="false"
      :ordemProp="ordemProp"
      @clickButton="clickButton"
      @ordena="obj => changeOrdem(obj)"
      @change-element="element => changeSelect(element)"
      @change-page="page => changePage(page.currentPage)"
      @download="download()"
      @filtro-click="showFiltro = true"
      @selectedElement="value => watchSelected(value)"
    />

    <component-loading style="height: 256px;" :value="isLoading" />
    <overlay-loading v-model="loadingOverlay" />
    <FiltroAreas v-model="showFiltro" @filtrar="params => filtrarAreaEmail(params)" />
    <error-modal
      v-model="error"
      :errObj="errObj"
    />
  </div>
</template>

<script>
import FiltroAreas from './FiltroAreas'
import EmailAreas from '../../../../services/EmailArea/EmailArea'
import { EventBus } from '../../../../services/EventBus/EventBus'

export default {
  components: {
    FiltroAreas
  },
  data () {
    return {
      selected: [],
      showFiltro: false,
      rows: [],
      rowsHeader: [
        { text: 'Unimed', icon: 'repeat' },
        { text: 'Área', icon: 'repeat' },
        { text: 'E-mail', icon: 'repeat' },
        { text: 'Status E-mails', icon: 'repeat' }
      ],
      elementsPerPage: 5,
      pagina: 1,
      qtResultados: -1,
      qtPaginas: -1,
      ordemProp: 'asc',
      ordem: '',
      indexHeader: '',
      paramsFiltro: '',

      emailsSelecionados: [],
      isLoading: false,
      loadingOverlay: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  beforeMount () {
    this.getEmail()
    EventBus.$on('reloadTabelaEmailAreas', reload => {
      if (reload) {
        this.getEmail(this.args())
        EventBus.$emit('reloadTabelaEmailAreas', false)
      }
    })
  },

  methods: {
    filtrarAreaEmail (parametroFiltro) {
      this.pagina = 1
      this.paramsFiltro = parametroFiltro
      this.showFiltro = false
      this.getEmail(this.args())
    },

    watchSelected (selected) {
      this.emailsSelecionados = []
      let show = true

      if (selected.length > 0) {
        show = false

        selected.forEach(item => {
          let obj = {
            id: this.rows[item].id,
            statusEmail: this.rows[item].email.statusEmail
          }
          this.emailsSelecionados.push(obj)
        })
      } else {
        show = true
      }

      this.$emit('showBotaoPendencia', show)
    },

    changeOrdem (obj) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc'

      switch (obj.index) {
        case 0:
          this.indexHeader = 'unimed'
          break
        case 1:
          this.indexHeader = 'tipoArea.nome'
          break
        case 2:
          this.indexHeader = 'email.endereco'
          break
        case 3:
          this.indexHeader = 'status'
          break
      }
      this.getEmail(this.args())
    },

    clickButton (obj) {
      const arrIds = []

      obj.selected.forEach((el) => {
        arrIds.push(this.rows[el].email)
      })
      switch (obj.type) {
        case 'delAll':
          this.$emit('reenviar', arrIds)
          break
      }
    },

    changeSelect (element) {
      if (
        element.elementsPerPage !== this.rows.length &&
        this.pagina < this.qtPaginas
      ) {
        this.elementsPerPage = element
        this.getEmail(this.args())
      } else {
        this.pagina = 1
        this.elementosPorPagina = element
        this.getEmail(this.args())
      }
    },

    changePage (pagina) {
      this.selected = []
      this.pagina = pagina
      this.getEmail(this.args())
    },

    args () {
      return `direcaoOrdenacao=${this.ordem}&ordenacao=${this.indexHeader}&pagina=${this.pagina}&tamanhoPagina=${this.elementsPerPage}&${this.paramsFiltro}`
    },

    async download () {
      let emailArea = new EmailAreas(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        this.loadingOverlay = true
        let response = await emailArea.getExportarArquivo(this.args())
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'emails.xlsx')
        document.body.appendChild(link)
        link.click()
        this.loadingOverlay = false
      } catch (err) {
        console.error(err)
      }
    },

    async getEmail (args = '') {
      this.isLoading = true
      this.$emit('loading', true)

      let emailArea = new EmailAreas(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await emailArea.getBuscarEmails(args)
        this.rows = response.data.conteudo
        this.pagina = response.data.pagina
        this.qtPaginas = response.data.qtPaginas
        this.qtResultados = response.data.qtResultados

        this.$emit('botao', this.rows.length > 0)
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      } finally {
        this.$emit('loading', false)
      }
    }
  }
}
</script>

<style lang="sass">
.emailArea > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.emailArea > .table-cadu > .table
  max-height: 220px
  overflow: auto
  table
    width: 100%
</style>
